import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const columnVariants = cva("column");

interface ColumnProps extends VariantProps<typeof columnVariants> {
  children: React.ReactNode;
  className?: string;
}

/**
 * Responsive grid component.
 * @param props
 * @constructor
 */
export function Column(props: ColumnProps) {
  const classes = cn(columnVariants({ className: props.className }));

  return (
    <div className={classes} data-testid="column">
      {props.children}
    </div>
  );
}
